import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-03/lesson-08/task-02";

const task: Slide = {
  title: "Indicate which of the depicted first order image sources are audible.",
  description: "Select the correct answer(s).",
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 1,
      colsSize: [3, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/08/task/task-2.svg`,
                },
              },
            },
          },
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
